import { Reveal } from "@/components/site/Reveal";

const INSTITUTIONS = [
  "Private Banks", "Family Offices", "External Asset Managers", "Hedge Funds", "Multi-Family Offices", "Wealth Managers",
];
const MEDIA = ["BFM Business", "Les Echos", "Bilan", "Monaco For Finance"];

export const TrustBar = () => {
  return (
    <section className="border-y border-[color:var(--bp-border)]/50 bg-[color:var(--bp-bg-2)] py-10" data-testid="trust-bar">
      <div className="container-bp">
        <Reveal>
          <p className="text-center text-[11px] font-semibold uppercase tracking-[0.2em] text-[color:var(--bp-text-muted)]/70">
            Trusted across Monaco &amp; Geneva&apos;s leading institutions
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-7 flex flex-wrap items-center justify-center gap-x-10 gap-y-5">
            {INSTITUTIONS.map((name) => (
              <span
                key={name}
                className="font-display text-[15px] text-[color:var(--bp-text-muted)]/55 transition-colors duration-300 hover:text-[color:var(--bp-cream)]"
              >
                {name}
              </span>
            ))}
          </div>
        </Reveal>
        <div className="mx-auto mt-8 max-w-3xl gold-divider opacity-50" />
        <Reveal delay={0.15}>
          <div className="mt-7 flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
            <span className="text-[10px] uppercase tracking-[0.22em] text-[color:var(--bp-text-muted)]/50">As featured in</span>
            {MEDIA.map((m) => (
              <span key={m} className="text-[12px] font-medium uppercase tracking-[0.14em] text-[color:var(--bp-text-muted)]/55 transition-colors hover:text-[color:var(--bp-gold)]">
                {m}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
